import React from 'react';
import UpcomingEventsWidget from '../components/UpcomingEventsWidget';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Ticket, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const EventsPage = ({ user, onLogout, refreshUserData }) => {
  const { t, language } = useLanguage();
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar */}
      <Navbar user={user} onLogout={onLogout} refreshUserData={refreshUserData} />
      
      {/* Spacer for fixed navbar */}
      <div className="h-20"></div>

      {/* Header */}
      <header className="bg-gradient-to-r from-brand-600 to-brand-800 text-white py-12 shadow-lg">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold">
            {language === 'en' ? 'Discover Events' : 'Découvrir des événements'}
          </h1>
          <p className="text-brand-100 mt-2">
            {language === 'en' ? 'Find exciting events near you' : 'Trouvez des événements passionnants près de chez vous'}
          </p>
        </div>
      </header>

      {/* Animated "Trouver des billets" Button */}
      <div className="bg-gradient-to-r from-amber-50 via-orange-50 to-amber-50 py-6 border-b border-amber-200">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-amber-800">
              <Sparkles className="w-5 h-5 animate-pulse" />
              <span className="font-medium">
                {language === 'en' ? 'Looking for tickets to an event?' : 'Vous cherchez des billets pour un événement?'}
              </span>
            </div>
            <a
              href="/facebook-groups"
              className="group relative inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-brand-500 to-brand-600 text-white font-bold text-lg rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
              data-testid="find-tickets-btn"
            >
              {/* Animated background shimmer */}
              <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 ease-in-out"></span>
              
              {/* Pulsing ring effect */}
              <span className="absolute inset-0 rounded-full animate-ping bg-brand-400 opacity-20"></span>
              
              <Ticket className="w-6 h-6 relative z-10 animate-bounce" />
              <span className="relative z-10">
                {language === 'en' ? 'Find Tickets' : 'Trouver des billets'}
              </span>
            </a>
          </div>
          <p className="text-center text-amber-700 text-sm mt-3">
            {language === 'en' 
              ? 'Join our affiliated Facebook groups to find tickets safely'
              : 'Rejoignez nos groupes Facebook affiliés pour trouver des billets en toute sécurité'
            }
          </p>
        </div>
      </div>

      {/* Events Widget */}
      <div className="py-8">
        <UpcomingEventsWidget 
          defaultRadius={50}
          defaultCountryCode="CA"
          autoLoad={false}
          showAllEvents={true}
        />
      </div>

      {/* Footer */}
      <Footer variant="simple" />

      {/* Custom CSS for animations */}
      <style jsx="true">{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
};

export default EventsPage;
